import React from 'react';
import PropTypes from 'prop-types';

import colors from 'theme/_colors.scss';

const IconBearingBSF = ({ width = 16, height = 16, viewBox = '0 0 16 16', color = colors.black }) => {
    return <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M9 3L7 3L7 1L9 1L9 3ZM9 7L7 7L7 5L9 5L9 7ZM9 11L7 11L7 9L9 9L9 11ZM9 15L7 15L7 13L9 13L9 15Z' fill={color} />
    </svg>;
};

IconBearingBSF.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconBearingBSF;
